import Link from "next/link"
import gql from "graphql-tag"
import { useQuery } from "react-apollo"

import "./question-of-the-day.scss"

const MOST_ANSWERED = gql`
  query QUESTION_OF_THE_DAY {
    questionsMostAnswered(first: 30) {
      id
      slug
      title
      answers(where: { blocked: false }) {
        id
      }
    }
  }
`

// The Nest's answered questions are its best content (the recent ones have no
// answers yet), so rotate through those with a few answers, one per UTC day.
const MIN_ANSWERS = 3

const QuestionOfTheDay = () => {
  const { data } = useQuery(MOST_ANSWERED)
  const answered = ((data && data.questionsMostAnswered) || []).filter(
    (q) => q.answers.length >= MIN_ANSWERS
  )
  if (answered.length === 0) return null
  const day = Math.floor(Date.now() / 86400000)
  const question = answered[day % answered.length]

  return (
    <section className="qotd" aria-labelledby="qotd-title">
      <div className="qotd__card">
        <h2 id="qotd-title" className="qotd__label">
          Question of the day from The Nest
        </h2>
        <p className="qotd__question">
          <Link href="/the-nest/q/[slug]" as={`/the-nest/q/${question.slug}`}>
            <a>{question.title}</a>
          </Link>
        </p>
        <p className="qotd__meta">{question.answers.length} answers from founders</p>
        <div className="qotd__actions">
          <Link href="/the-nest/q/[slug]" as={`/the-nest/q/${question.slug}`}>
            <a className="qotd__primary">Read the answers</a>
          </Link>
          <Link href="/the-nest">
            <a className="qotd__secondary">Browse The Nest</a>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default QuestionOfTheDay
